import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik } from 'formik'
import * as yup from 'yup'
import to from 'await-catch'
import { changePassword } from '../../../api'
import {
	FormContainer,
	BackButton,
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	HeaderDesktop,
	HeaderMobile,
	MobileBackButton,
	FormSubtitleBold,
	EmptySpace
} from '../../ui/form'
import Input from '../../ui/input'
import { Button } from '../../ui/button'
import { Container } from './styled'
import theme from '../../../styled/theme'
import { ChevronLeft, ChevronRight } from '../../../assets/icons'
import Feedback from '../../feedback'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const NewPassword = () => {
	const initialValues = { password: '' }
	const validationSchema = yup.object().shape({
		password: yup
			.string()
			.required('Campo requerido'),
		confirmPassword: yup
			.string()
			.oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir')
			.required('Campo requerido')
	})
	const [messageResult, setMessageResult] = useState(false)
	const [errorResult, setErrorResult] = useState(false)
	const location = useLocation();
	const history = useHistory()
	const isForgottenPassword = location.pathname.includes('cambiar-contrasenia');

	const handleBack = () => {
		history.push('/')
	}

	const handleSubmit = async ({ password }) => {
		const hash = new URLSearchParams(window.location.search).get(isForgottenPassword ? 'hash' : 'email')

		const [err] = await to(changePassword(hash, password))
		if (!err) {
			setMessageResult(true)
		} else {
			setErrorResult(true)
		}
	}

	if (messageResult) {
		return (
			<Feedback
				title="La contraseña se cambió exitosamente"
				onClickButton={handleBack}
			/>
		)
	} else if (errorResult) {
		return (
			<Feedback
				title="Hubo un error al cambiar la contraseña"
				isError={true}
				onClickButton={handleBack}
			/>
		)
	}

	return (
		<>
			<FormContainer justify="between" paddingMobile={'20px 0px 30px 0px'} gap={32}>
				<Formik
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={handleSubmit}
				>
					{({ values, errors, handleChange, handleSubmit }) => (
						<>
							<Container>
								<HeaderDesktop>
									<BackButton onClick={handleBack}>
										<ChevronLeft color={theme.colors.brand.blueOmint} />
										<LinkButton>Volver</LinkButton>
									</BackButton>
								</HeaderDesktop>
								<HeaderMobile>
									<MobileBackButton onClick={handleBack}>
										<ChevronRight color={theme.colors.brand.blueOmint} />
									</MobileBackButton>
									<FormSubtitleBold>Cambiá tu contraseña</FormSubtitleBold>
									<EmptySpace />
								</HeaderMobile>
								<FormHeader align="start" gap={8} mb={0}>
									<FormTitle align="left" mb={0}>
										Cambiá tu contraseña
									</FormTitle>
								</FormHeader>
								<InputsContainer gap={24} mb={16}>
									<Input
										label="Contraseña"
										type="password"
										name="password"
										placeholder="Ingresá tu nueva contraseña"
										value={values.password}
										onChange={handleChange}
										error={errors.password}
										isPassword
										fullWidth
									/>
									<Input
										label="Repetí la contraseña"
										type="password"
										name="confirmPassword"
										placeholder="Reingresá tu nueva contraseña"
										value={values.confirmPassword}
										onChange={handleChange}
										error={errors.confirmPassword}
										isPassword
										fullWidth
									/>
								</InputsContainer>
							</Container>
							<ButtonsContainer gap={24}>
								<Button
									label="Cambiar"
									$variant="primary"
									size="mobile"
									onClick={handleSubmit}
									disabled={!values.password || !values.confirmPassword || values.password !== values.confirmPassword}
								/>
							</ButtonsContainer>
						</>
					)}
				</Formik>
			</FormContainer>
		</>
	)
}

export default NewPassword
